export default ({ form }: any) => {
    // 表单本地空间，用来存储额外数据
    if (!form._local) {
        form._local = {}
    }

    // 设置本地数据
    form.setLocalData = (name, data) => {
        form._local[name] = {
            ...(form._local[name] || {}),
            ...data
        }
    }

    // 获取本地数据
    form.getLocalData = name => {
        if (name) {
            return form._local?.[name]
        }

        return form._local
    }
}
